import { enqueueSnackbar } from 'notistack';
import ApiBase from '../base/apiBase';
import { store } from '../../redux/store';
import { SaveRequest, SaveSingleRequest } from '../../redux/slices/requests';
import { prepareUpdatedData } from 'helpers/stateChanges';

export class RequestsService {
  private static apiBase = new ApiBase<any>();

  public static async getRequest(
    idOrSlug?: string | number,
    searchQuery?: string,
    limit?: number,
    offset?: number,
    ordering?: string,
    idParam: 'jobID' | 'profileID' = 'jobID'
  ): Promise<any | null> {
    const { dispatch } = store;
    try {
      const queryParams = new URLSearchParams();
      if (idOrSlug) queryParams.append(idParam, idOrSlug.toString());
      if (searchQuery) queryParams.append('q', searchQuery);
      if (limit !== undefined) queryParams.append('limit', limit.toString());
      if (offset !== undefined) queryParams.append('offset', offset.toString());
      if (ordering) queryParams.append('ordering', ordering);
      const res = await this.apiBase.getAsync(
        `/candidates/profile-requests/?${queryParams.toString()}`
      );
      if (idOrSlug) {
        dispatch(SaveSingleRequest(res));
      } else {
        dispatch(SaveRequest(res));
      }
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  public static async changeRequest(
    body: any,
    idOrSlug?: string | number,
    single?: string
  ): Promise<any | null> {
    const { dispatch } = store;
    try {
      const res = await this.apiBase.updateAsync(
        `/candidates/profile-requests/${idOrSlug || ''}/`,
        body
      );
      if (single) {
        const updatedState = prepareUpdatedData(
          'update',
          'requests',
          res,
          'singleRequest'
        );

        dispatch(SaveSingleRequest(updatedState));
      } else {
        const updatedState = prepareUpdatedData(
          'update',
          'requests',
          res,
          'request'
        );
        dispatch(SaveRequest(updatedState));
      }
      if (body?.status === 4) {
        enqueueSnackbar('Request Cancelled', {
          variant: 'success'
        });
      }
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  public static async sendRequest(
    body?: any,
    refresh?: { limit?: number; offset?: number }
  ): Promise<any | null> {
    try {
      const res = await this.apiBase.postAsync(
        `/candidates/profile-requests/`,
        body
      );

      if (res?.id) {
        const originId = body?.origin_job ?? body?.origin_profile;
        const limit = refresh?.limit ?? 10;
        const offset = refresh?.offset ?? 0;

        if (originId) {
          await this.getRequest(originId, undefined, limit, offset);
        }

        // Keep the global outgoing list in sync (Candidate Overview tab).
        await this.getRequest(undefined, undefined, 6, 0);
      }

      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  public static async acceptProfileRequest(id: number): Promise<any> {
    return this.apiBase.getAsync(`/candidates/profile-requests/${id}/accept/`);
  }

  public static async denyProfileRequest(id: number): Promise<any> {
    return this.apiBase.getAsync(`/candidates/profile-requests/${id}/deny/`);
  }
}
